import produce, { Draft } from "immer"
//import { Rating } from "../common/types/rating"


type Message = {
    page: string
    type: string
    title: string
    message: string
}

type ListMessages = Message[]

type State = {
    messages: ListMessages
}

const rating = {
  state: {
    messages: []
  } as State,
  reducers: {
    add: produce((draft: Draft<State>, payload: Message) => {
      draft.messages.push(payload);
    })
  }
}

export default rating